module.exports = __webpack_public_path__ + "static/media/user.48956991.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/user.svg
// module id = 509
// module chunks = 1